import { render, staticRenderFns } from "./batchScanCode.vue?vue&type=template&id=fa6393e0&scoped=true&"
import script from "./batchScanCode.vue?vue&type=script&lang=js&"
export * from "./batchScanCode.vue?vue&type=script&lang=js&"
import style0 from "./batchScanCode.vue?vue&type=style&index=0&id=fa6393e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6393e0",
  null
  
)

export default component.exports